const initialState = {
  code: '',
  defaultMessage: '',
  status: 'init',
  companyId: '',
  regionalId: '',
  officeId: '',
  offices: [],
  user: {
    login: '',
    name: '',
    profile: 0,
    status: 'loading',
    companies: [],
    regionals: [],
    offices: [],
  },
};

const authentication = (state = initialState, action) => {
  switch (action.type) {
    case 'FAILED_USERS_AUTHENTICATION':
      return {
        ...state,
        code: action.payload ? action.payload.code : '',
        defaultMessage: action.payload ? action.payload.defaultMessage : '',
        status: 'failed',
        officeId: '',
        offices: [],
        user: {}
      };
    case 'VALID_USERNAME_PASSWORD':
      return {
        ...state,
        status: 'valid_username_password',
        user: {
          ...state.user,
          login: action.payload.user.login,
        }
      };
    case 'SUCCESS_USERS_SELF_DATA':
      return {
        ...state,
        code: '',
        defaultMessage: '',
        status: 'success',
        user: { ...action.payload, status: 'success' }
      }
    case 'OFFICE_CONTEXT_UPDATED':
      return {
        ...state,
        companyId: action.payload?.companyId,
        regionalId: action.payload?.regionalId,
        officeId: action.payload?.officeId,
      }
    case 'SUCCESS_USERS_LOGOUT':
      return { ...initialState };
    case 'SUCCESS_GET_COMPANIES':
      return {
        ...state,
        user: {
          ...state.user,
          companies: action.payload,
        }
      }
    case 'SUCCESS_GET_REGIONALS':
      return {
        ...state,
        user: {
          ...state.user,
          regionals: action.payload,
        }
      }
    case 'SUCCESS_GET_OFFICES':
      return {
        ...state,
        user: {
          ...state.user,
          offices: action.payload,
        }
      }
    case 'SUCCESS_SELECTED_COMPANY':
      return {
        ...state,
        companyId: action.payload,
        regionalId: '',
        officeId: '',
      }
    case 'SUCCESS_SELECTED_REGIONAL':
      return {
        ...state,
        regionalId: action.payload,
        officeId: '',
      }
    case 'SUCCESS_SELECTED_OFFICE':
      return {
        ...state,
        officeId: action.payload,
      }
    default:
      return state;
  }
}

export default authentication;
